import { render } from "./massive-table-test.vue?vue&type=template&id=3aa3498d&scoped=true"
import script from "./massive-table-test.vue?vue&type=script&lang=js"
export * from "./massive-table-test.vue?vue&type=script&lang=js"

import "./massive-table-test.vue?vue&type=style&index=0&id=3aa3498d&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa3498d"]])

export default __exports__